import { FLOOR_TYPE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IFloorType } from "../../shared/interfaces/floor-type/IFloorType";

export const FloorTypeService = {
  getAll: (params: IPagination) => requests.get(FLOOR_TYPE_URL, params),
  create: (params: IFloorType) => requests.post(`${FLOOR_TYPE_URL}`, params),
  getSingle: (id: number) => requests.get(`${FLOOR_TYPE_URL}/${id}`),
  update: (params: IFloorType, id: number) =>
    requests.put(`${FLOOR_TYPE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${FLOOR_TYPE_URL}/${id}`),
};
